import React from 'react';

import { Content } from './Content.js';
import LogosExtension from './LogosExtension.jsx';

export default class UnderPipePanel extends React.Component {

  render() {
    const pipeClass = (this.props.noPipes === true) ? 'nopipes' : '';

    return (
      <div className={`ContactUnderPipePanel row ${this.props.section} ${pipeClass}`}>
        <div className="stroke vertical left"></div>
        <div className="stroke vertical right"></div>
        <div className="main-content col-xs-16">
          <div className="col-xs-16 col-md-10">
            <h2>{Content[this.props.section].title}</h2>
            <p className="body">{Content[this.props.section].body}</p>
            <div className="stagwell-logo">
              <a href={Content.extension.anchor.href} target="_blank" rel="noopener noreferrer">
                <img src="../../assets/img/stagwell-group.png" alt="Stagwell Group"/>
              </a>
            </div>
          </div>
          <div className="col-xs-16 col-md-6 logos-extension">
            <LogosExtension page={this.props.page}/>
          </div>
        </div>

      </div>
    );
  }

};
